import { SortingConfigTypes } from '../constants/ModelFamilyList';
import { PromotionType } from '../types/offers';
import { GroupedOffers } from './groupOffers';

export const sortVehicleByModel = (offers: GroupedOffers, sortingConfig: SortingConfigTypes) => {
  const sortedObj: GroupedOffers = {};
  Object.entries(offers).forEach(([groupKey, groupValue]) => {
    const sortOrder = sortingConfig[groupKey];
    if (sortOrder) {
      sortedObj[groupKey] = Object.fromEntries(
        Object.entries(groupValue).sort((a, b) => {
          const indexA = sortOrder.indexOf(a[0]);
          const indexB = sortOrder.indexOf(b[0]);
          return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
        }),
      );
    } else {
      sortedObj[groupKey] = groupValue;
    }
  });
  return sortedObj;
};

export const sortVehicle = (offers: PromotionType[], sortingConfig: string[]) => {
  return offers.sort((a, b) => {
    return (
      sortingConfig.indexOf(
        a.offerModelDetail.modelFamily.toLowerCase().replace(/[^a-z0-9]/g, ''),
      ) -
      sortingConfig.indexOf(b.offerModelDetail.modelFamily.toLowerCase().replace(/[^a-z0-9]/g, ''))
    );
  });
};

export const sortByDag = (offers: PromotionType[], priorityOrder: string[]) => {
  const orderMap = new Map(priorityOrder.map((dag, index) => [dag, index]));
  const sortedTiles = offers.sort((a, b) => {
    const orderA = orderMap.get(a.offerModelDetail.dag) ?? priorityOrder.length;
    const orderB = orderMap.get(b.offerModelDetail.dag) ?? priorityOrder.length;
    return orderA - orderB;
  });
  return sortedTiles;
};
